import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { brands } from "@/data/content";

const points = [
  "pečlivá příprava podkladu",
  "kvalitní materiály",
  "precizní provedení detailů",
  "ověřené pracovní postupy",
  "kontrola kvality před předáním",
];

export const Materials = () => (
  <section className="bg-card" data-testid="materials-section">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-28">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
            Materiály a zpracování
          </p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            Kvalitní výsledek začíná správným postupem.
          </h2>
          <ul className="mt-8 flex flex-col gap-3.5">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-base text-foreground">
                <Check className="mt-1 h-4 w-4 shrink-0 text-accent" />
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.12} className="flex flex-col lg:col-span-7">
          <figure className="flex-1">
            <img
              src="./images/fasada-rodinny-dum.jpg"
              alt="Dokončená fasáda rodinného domu"
              className="h-72 w-full rounded-md object-cover lg:h-[380px]"
              loading="lazy"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">
              Fasáda rodinného domu · dokončená realizace
            </figcaption>
          </figure>
          <div className="mt-10 border-t border-border pt-6">
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Pracujeme se systémy
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-x-8 gap-y-3" data-testid="brand-list">
              {brands.map((b) => (
                <span key={b} className="text-sm font-semibold uppercase tracking-widest text-sand">
                  {b}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
